import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { LINKEDIN_WIZARDS } from '@bingads-webui-campaign-react/linkedin-utils';
import { mergeClasses } from '@fluentui/react-components';

import { LinkedInBaseSingleStepWizard } from './base-single-step-wizard';
import { useWizardStyles } from './styles/wizard-styles';

const getNavigationProps = scope => ({
  pathname: '/campaign/vnext/ads',
  search: `?uid=${scope.values.uid}&cid=${scope.values.cid}&aid=${scope.values.aid}&campaignId=${scope.values.campaignId}&adGroupId=${scope.values.adGroupId}`,
});

export const LinkedInAdEditorWizard = ({ scope, ...restProps }) => {
  const classes = useWizardStyles();
  const navigateToSomeWhere = useCallback(() => {
    const { pathname, search } = getNavigationProps(scope);

    scope.history.push({ pathname, search });
  }, [scope]);

  return (
    <div className={mergeClasses('ad-editor-wizard', classes.wizardContainer)}>
      <LinkedInBaseSingleStepWizard
        scenario={LINKEDIN_WIZARDS.AD_EDITOR}
        onDone={navigateToSomeWhere}
        onExited={navigateToSomeWhere}
        {...restProps}
      />
    </div>
  );
};

LinkedInAdEditorWizard.propTypes = {
  scope: PropTypes.shape({
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
  }).isRequired,
};
